// extracted by mini-css-extract-plugin
var _1 = "StickyNav_StickyNav__EnBqn";
var _2 = "StickyNav_icon__W0O-V";
export { _1 as "StickyNav", _2 as "icon" }
